// extracted by mini-css-extract-plugin
export var currencyInput = "_jn-1";
export var currencySymbol = "_jn-0";